import { useEffect, useState } from 'react';
import { useTimeZone } from 'hooks';
import { AppConstants } from 'constants/index';
import { StyledHeaderDateTime } from 'app/layout/components/Layout.styled';

const DateTime = () => {
  const [time, setTime] = useState<string|null>(null);

  const { getFormattedDate, getDateTz } = useTimeZone();

  useEffect(() => {
    const intervalId = setInterval(() => {
      const formatted = getFormattedDate(getDateTz(), AppConstants.format.dateTime);
      setTime((prev) => (prev !== formatted ? formatted : prev));
    }, 1000);

    return () => clearInterval(intervalId);
  }, [getFormattedDate, getDateTz]);

  return <StyledHeaderDateTime>{time}</StyledHeaderDateTime>;
};

export default DateTime;
